import { render, staticRenderFns } from "./TablesMain.vue?vue&type=template&id=42b2b487&scoped=true&"
import script from "./TablesMain.vue?vue&type=script&lang=js&"
export * from "./TablesMain.vue?vue&type=script&lang=js&"
import style0 from "./TablesMain.vue?vue&type=style&index=0&id=42b2b487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2b487",
  null
  
)

export default component.exports